
export function devEnv() {
    return !process.env.NODE_ENV || process.env.NODE_ENV === 'development';
}

export function logError(e) {
    if (devEnv()) {
        console.error(e);
    }
}